import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Phone, Lock, ArrowRight, Loader2, Home } from 'lucide-react';
import Bubbles from '../Bubbles'; 
import './Login.css';

const Login = () => {
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [response, setResponse] = useState(null);
  const [loading, setLoading] = useState(false);
  const [darkMode, setDarkMode] = useState(false); // 🔴 حالة الـ Dark Mode
  const navigate = useNavigate();

  // 🔴 جلب حالة الـ Dark Mode عند تحميل الصفحة
  useEffect(() => {
    const savedMode = localStorage.getItem("darkMode");
    setDarkMode(savedMode === "true");
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/login`, {
        phone,
        password,
      });

      const { data } = res;
      setResponse(data);

      localStorage.setItem('authToken', data.token);
      localStorage.setItem('educationalLevelId', data.user.educational_level_id);
      localStorage.setItem('id', data.user.id);

      navigate('/Teachers');
    } catch (error) {
      setError('برجاء التأكد من رقم الهاتف أو كلمة المرور 🚫');
    } finally {
      setLoading(false);
    }
  };

  const BackHome = () => {
    navigate('/');
  };

  return (
    /* 🔴 إضافة كلاس dark-mode هنا بناءً على الحالة */
    <div className={`split-login-container ${darkMode ? "dark-mode" : ""}`}>
      
      {/* النصف الأيسر: الصورة والهوية البصرية */}
      <div
        className="login-left-side"
        style={{ 
          // 🔴 تغيير الخلفية لو الوضع الليلي شغال (تقدر تغير مسار الصورة براحتك)
          background: `url(${darkMode ? '/images/backgroud-dark=.png' : '/images/backgroud2s.png'}) center/cover no-repeat` 
        }}
      >
        <div className="overlay-gradient"></div>
        <motion.div
          className="brand-content"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
        >
          <h1>Edu <span>Masr</span></h1>
          <p>بوابتك الذكية للتعلم الإلكتروني والتفوق الدراسي. انضم إلينا وابدأ رحلة نجاحك اليوم.</p>
        </motion.div>
      </div>

      {/* النصف الأيمن: الفورم وتسجيل الدخول */}
      <div className="login-right-side">
        <motion.div
          className="form-wrapper"
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div className="form-header">
            <h2>تسجيل الدخول</h2>
            <p>مرحباً بعودتك! برجاء إدخال بياناتك للمتابعة.</p>
          </div>

          <form onSubmit={handleSubmit} className="modern-login-form">
            <div className="input-group">
              <label>رقم الهاتف المحمول</label>
              <div className="input-with-icon">
                <Phone size={20} className="input-icon" />
                <input
                  type="text"
                  placeholder="01xxxxxxxxx"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  disabled={loading}
                  required
                />
              </div>
            </div>

            <div className="input-group">
              <label>كلمة المرور</label>
              <div className="input-with-icon">
                <Lock size={20} className="input-icon" />
                <input
                  type="password"
                  placeholder="أدخل كلمة المرور"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  disabled={loading}
                  required
                />
              </div>
            </div>

            {error && (
              <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="error-alert">
                {error}
              </motion.div>
            )}

            {response && (
              <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="success-alert">
                تم تسجيل الدخول بنجاح 🎉
              </motion.div>
            )}

            <button type="submit" className="btn-primary-login" disabled={loading}>
              {loading ? (
                <>
                  <Loader2 className="spinner" size={20} />
                  <span>جاري التحقق...</span>
                </>
              ) : (
                <>
                  <span>دخول</span>
                  <ArrowRight size={20} />
                </>
              )}
            </button>
          </form>

          <div className="form-footer">
            <p>ليس لديك حساب؟ <a href="/Signup">إنشاء حساب جديد</a></p>
            <div className="divider">أو</div>
            <button type="button" className="btn-secondary-home" onClick={BackHome} disabled={loading}>
              <Home size={18} />
              <span>العودة للرئيسية</span>
            </button>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Login;